export function mapAqiToColor(v) {
    if (v == '-' || v == 'placeholder') {
        return '#888888';
    }
    else if (v <= 50) {
        return '#009966';
    }
    else if (v <= 100) {
        return '#ffde33';
    }
    else if (v <= 150) {
        return '#ff9933';
    }
    else if (v <= 200) {
        return '#cc0033';
    }
    else if (v <= 300) {
        return '#660099';
    }
    else
        return '#7e0023';
}
export function mapAqiToTextColor(v) {
    if (v <= 50) {
        return '#ffffff';
    }
    else if (v <= 100) {
        return '#000000';
    }
    else if (v <= 150) {
        return '#000000';
    }
    else if (v <= 200) {
        return '#ffffff';
    }
    else if (v <= 300) {
        return '#ffffff';
    }
    else
        return '#ffffff';
}
function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
export function colorMixer(c1, c2, r) {
    var c = '#';
    for (var i = 0; i < 3; i++) {
        var v1 = parseInt(c1.substr(1 + i * 2, 2), 16);
        var v2 = parseInt(c2.substr(1 + i * 2, 2), 16);
        var v = Math.round(v1 + (v2 - v1) * r);
        v = Math.min(255, Math.max(0, v));
        var sv = v.toString(16);
        if (sv.length == 1)
            sv = '0' + sv;
        c += sv;
    }
    return c;
}
function colorRangeMixer(v, c) {
    var n = c.c.length;
    var start = c.f, stop = start + n * c.s;
    if (v <= start)
        return c.c[0];
    if (v >= stop - c.s)
        return c.c[n - 1];
    v -= start;
    var idx = Math.floor(v / c.s);
    var perc = (v - idx * c.s) / c.s;
    if (idx >= n - 1)
        idx = n - 2;
    var r = colorMixer(c.c[idx], c.c[idx + 1], perc);
    return r;
}
export function aqiColor(aqi, item, pol) {
    if (item == 'ts')
        return aqiColor(aqi, 'f', pol);
    if (item == 's')
        return aqiColor(aqi, 'f', pol) == '#ffffff' ? '#000000' : '#ffffff';
    if (pol == 'd')
        pol = 't';
    if (pol)
        pol = pol.replace('met.', '');
    var colors = {
        co2: {
            f: 400,
            s: 50,
            c: ['#cccccc', '#888888', '#444444'],
        },
        t: {
            f: -20,
            s: 10,
            c: [
                '#022887',
                '#326DE1',
                '#80A7FD',
                '#A4EE27',
                '#FEEC00',
                '#FFBA01',
                '#FF7A01',
                '#F62304',
                '#C40305',
                '#8D0000',
            ],
        },
        h: {
            f: 0,
            s: 100,
            c: ['#FEEC00', '#326DE1'],
        },
        w: {
            f: 0,
            s: 1,
            //https://gka.github.io/palettes/#/9|s|a0bbf1,00b4f1,326de1|ff005e|0|1
            c: [
                '#a0bbf1',
                '#8bb8f1',
                '#77b4f0',
                '#65adef',
                '#54a4ed',
                '#4699eb',
                '#3b8ce8',
                '#357ee5',
                '#326de1',
            ],
        },
        p: {
            f: 980,
            s: 5,
            //https://gka.github.io/palettes/#/9|s|00429d,55bfac,00ddc2|ffffe0,ff005e,93003a|0|1
            c: [
                '#00429d',
                '#2d5ea2',
                '#3c78a6',
                '#4390aa',
                '#45a6af',
                '#42b8b3',
                '#3ac8b7',
                '#2bd4bc',
                '#00ddc2',
            ],
        },
        r: {
            f: 0,
            s: 10,
            //https://gka.github.io/palettes/#/9|s|788ef5,00429d|ff005e|0|1
            c: ['#788ef5', '#00429d'],
        },
    };
    if (pol && pol in colors) {
        if (item == 'f')
            return '#000000';
        return colorRangeMixer(aqi, colors[pol]);
    }
    if (pol == 'uvi') {
        if (item == 'f')
            return '#ffffff';
        if (aqi <= 2)
            return '#289500';
        if (aqi <= 5)
            return '#F7E400';
        if (aqi <= 7)
            return '#F85900';
        if (aqi <= 10)
            return '#D8001D';
        return '#6B49C8';
    }
    if (!isNumeric(aqi) || aqi <= 0) {
        if (item == 'b')
            return '#cccccc';
        return '#000000';
    }
    var range = [
        { a: 50, b: '#009966', f: '#ffffff' },
        { a: 100, b: '#ffde33', f: '#000000' },
        { a: 150, b: '#ff9933', f: '#000000' },
        { a: 200, b: '#cc0033', f: '#ffffff' },
        { a: 300, b: '#660099', f: '#ffffff' },
        { a: -1, b: '#7e0023', f: '#ffffff' },
    ];
    for (var i in range) {
        var c = range[i];
        if (aqi <= c.a || c.a == -1) {
            return c[item];
        }
    }
    return range[range.length - 1][item];
}
export function aqiSmoothColor(aqi, item, pol) {
    if (item === void 0) { item = 'b'; }
    if (pol === void 0) { pol = 'pm25'; }
    if (pol)
        pol = pol.replace('met.', '');
    if (['td', 's', 'd', 't', 'h', 'w', 'p', 'uvi', 'co2', 'r'].indexOf(pol) >=
        0)
        return aqiColor(aqi, item, pol);
    if (!isNumeric(aqi) || aqi <= 0) {
        if (item == 'b')
            return '#cccccc';
        if (item == 's')
            return '#ffffff80';
        return '#888888';
    }
    if (item == 's') {
        if (aqi >= 20 && aqi <= 130)
            return '#ffffff80';
        return '#00000080';
    }
    if (item == 'f') {
        if (aqi >= 20 && aqi <= 130)
            return '#000000';
        return '#ffffff';
    }
    // if (aqi>=25 && aqi<50) return colorMixer("#009966","#ffde33",(aqi-25)/25);
    if (aqi <= 50)
        return colorMixer('#009966', '#ffde33', (aqi - 0) / 50);
    if (aqi >= 75 && aqi <= 100)
        return colorMixer('#ffde33', '#ff9933', (aqi - 75) / 25);
    if (aqi >= 125 && aqi <= 150)
        return colorMixer('#ff9933', '#cc0033', (aqi - 125) / 25);
    if (aqi >= 175 && aqi <= 200)
        return colorMixer('#cc0033', '#660099', (aqi - 175) / 25);
    return aqiColor(aqi, 'b');
}
